import React, { useState, useEffect } from 'react';
import api from '../services/api';

const formatCurrency = (amount) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

const InvoiceTemplate = ({ dealId }) => {
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getInvoiceData(dealId);
        setInvoiceData(response);
      } catch (error) {
        console.error('Failed to fetch invoice data', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dealId]);

  if (loading) {
    return <div className="p-8">Loading...</div>;
  }

  if (!invoiceData) {
    return <div className="p-8">Failed to load invoice data.</div>;
  }

  const { deal, vehicle, buyer } = invoiceData;
  const subtotal = parseFloat(deal.sale_price) + parseFloat(deal.doc_fee) + parseFloat(deal.title_fee || 0) + parseFloat(deal.temp_tag_fee || 0);
  const total = subtotal + parseFloat(deal.sales_tax || 0);

  return (
    <div className="bg-white p-8 max-w-4xl mx-auto my-4 border">
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-2xl font-bold">Alexis Motorcar LLC</h1>
          <p>4001 W Alexis Rd</p>
          <p>Toledo, OH 43623</p>
          <p>Phone: 419-242-1005</p>
        </div>
        <div>
          <h2 className="text-3xl font-bold text-gray-700">INVOICE</h2>
          <p><strong>Invoice #:</strong> {deal.id}</p>
          <p><strong>Date:</strong> {new Date(deal.created_at).toLocaleDateString()}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-8 mb-8">
        <div>
          <h3 className="font-bold mb-2">BILL TO</h3>
          <p>{buyer.name}</p>
          {buyer.address && <p>{buyer.address}</p>}
          {buyer.phone && <p>{buyer.phone}</p>}
        </div>
        <div>
          <h3 className="font-bold mb-2">VEHICLE</h3>
          <p>{vehicle.year} {vehicle.make} {vehicle.model}</p>
          <p><strong>VIN:</strong> {vehicle.vin}</p>
          <p><strong>Stock #:</strong> {vehicle.stock_number}</p>
          <p><strong>Mileage:</strong> {vehicle.mileage}</p>
        </div>
      </div>

      <table className="w-full mb-8">
        <thead>
          <tr className="bg-gray-200">
            <th className="text-left p-2">Description</th>
            <th className="text-right p-2">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr><td className="p-2">Vehicle Price</td><td className="text-right p-2">{formatCurrency(deal.sale_price)}</td></tr>
          <tr><td className="p-2">Doc Fee</td><td className="text-right p-2">{formatCurrency(deal.doc_fee)}</td></tr>
          {deal.title_fee > 0 && <tr><td className="p-2">Title Fee</td><td className="text-right p-2">{formatCurrency(deal.title_fee)}</td></tr>}
          {deal.temp_tag_fee > 0 && <tr><td className="p-2">Temp Tag</td><td className="text-right p-2">{formatCurrency(deal.temp_tag_fee)}</td></tr>}
          <tr className="border-t"><td className="p-2 font-bold">SUBTOTAL</td><td className="text-right p-2 font-bold">{formatCurrency(subtotal)}</td></tr>
          {deal.sales_tax > 0 && <tr><td className="p-2">Sales Tax</td><td className="text-right p-2">{formatCurrency(deal.sales_tax)}</td></tr>}
          <tr className="border-t-2 border-black"><td className="p-2 font-bold text-lg">TOTAL DUE</td><td className="text-right p-2 font-bold text-lg">{formatCurrency(total)}</td></tr>
          {deal.deposit > 0 && <tr><td className="p-2">Less: Deposit Received</td><td className="text-right p-2">({formatCurrency(deal.deposit)})</td></tr>}
          <tr className="border-t"><td className="p-2 font-bold">BALANCE DUE</td><td className="text-right p-2 font-bold">{formatCurrency(deal.balance_due)}</td></tr>
        </tbody>
      </table>

      <div className="mt-12">
        <div className="w-1/2 border-t border-black pt-2">
          Signature
        </div>
      </div>
    </div>
  );
};

export default InvoiceTemplate;
